import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {Observable} from 'rxjs';
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {UserRequestDetailComponent} from "../user-request-detail/user-request-detail.component";
import {SearchBarComponent} from "../../../common/search-bar/search-bar.component";
import {SearchPipe} from "../../../common/SearchPipe";
import {DynamicModalFormComponent} from "../../../common/dynamic-modal-form/dynamic-modal-form.component";
import {UserRequest} from "../../../../model/UserRequest";
import {UserService} from "../../../../services/user.service";
import {DynamicTableComponent} from "../../../common/dynamic-table/dynamic-table.component";

@Component({
    selector: 'app-user-requests-table',
    imports: [
        CommonModule,
        SearchBarComponent,
        SearchPipe,
        NgbTooltip,
        FaIconComponent,
        DynamicModalFormComponent,
        UserRequestDetailComponent,
        DynamicTableComponent
    ],
    templateUrl: './user-requests-table.component.html',
    styleUrls: ['./user-requests-table.component.css']
})
export class UserRequestsTableComponent implements OnInit {

  @Input() requests: UserRequest[];

  @Output()
  detail = new EventEmitter<UserRequest>();
  @Output()
  take = new EventEmitter<UserRequest>();
  @Output()
  untake = new EventEmitter<UserRequest>();
  @Output()
  accept = new EventEmitter<UserRequest>();
  @Output()
  partialAccept = new EventEmitter<UserRequest>();
  @Output()
  reject = new EventEmitter<UserRequest>();

  username: string;
  crmUrl: Observable<string>;
  toUntake: UserRequest;

  forceUntakeActions = [{label: 'Confirmer', class: 'btn-primary', icon:''}]

  search: string;

  headers = [
    {
      label: 'État',
      sortable: true,
      property: 'accepted',
      customSort: (a, b) =>  a.accepted === b.accepted ? 0 : a.accepted === null ? -1 : 1
    },
    {
      label: 'Utilisateur',
      sortable: true,
      property: 'contact.firstname',
      customSort: (a, b) => a.contact.firstname.localeCompare(b.contact.firstname),
    },
    {
      label: 'Structure',
      sortable: true,
      property: 'contact.account.name',
      customSort: (a, b) => a.contact.account.name.localeCompare(b.contact.account.name),
    },
    {
      label: 'Date de la demande',
      sortable: true,
      property: 'date',
    },
    {
      label: 'Pour',
      sortable: true,
      property: 'coords.email',
      customSort: (a, b) => a.coords.email.localeCompare(b.coords.email),
    }
  ];

  actions = [
    {
      icon: 'eye',
      eventHandler: (item) => this.seeDetail(item),
      cssClass: 'text-info',
      tooltip: 'Voir les détails de la demande'
    },
    {
      icon: 'handshake',
      eventHandler: (item) => this.takeHandler(item),
      cssClass: 'text-info',
      tooltip: 'Prendre en charge',
      condition: (item) => item.accepted === null && item.handledBy === null
    },
    {
      icon: 'handshake-slash',
      eventHandler: (item) => this.untakeHandlerConfirm(item),
      cssClass: 'text-warning',
      tooltip: 'Annuler la prise en charge',
      condition: (item) => item.accepted === null && item.handledBy !== null && item.handledBy !== this.username
    },
    {
      icon: 'handshake-slash',
      eventHandler: (item) => this.untakeHandler(item),
      cssClass: 'text-info',
      tooltip: 'Annuler la prise en charge',
      condition: (item) => item.accepted === null && item.handledBy === this.username
    },
    {
      icon: 'check',
      eventHandler: (item) => this.acceptHandler(item),
      cssClass: 'text-success',
      tooltip: 'Accepter la demande',
      condition: (item) => item.accepted === null && item.handledBy === this.username
    },
    {
      icon: 'check',
      eventHandler: (item) => this.partialAcceptHandler(item),
      cssClass: 'text-warning',
      tooltip: 'Accepter partiellement la demande',
      condition: (item) => item.accepted === null && item.handledBy === this.username
    },
    {
      icon: 'times',
      eventHandler: (item) => this.rejectHandler(item),
      cssClass: 'text-danger',
      tooltip: 'Refuser la demande',
      condition: (item) => item.accepted === null && item.handledBy === this.username
    }
  ];

  constructor(private keycloakService: KeycloakService,
              private userRequestService: UserService) {
  }

  ngOnInit(): void {
    this.keycloakService.loadUserProfile().then((profile) => {
      this.username = profile.username;
    });
    this.crmUrl = this.userRequestService.getCrmUrl();
  }

  seeDetail(ur: UserRequest): void {
    this.detail.emit(ur);
  }

  takeHandler(ur: UserRequest): void {
    this.take.emit(ur);
  }

  untakeHandler(ur: UserRequest): void {
    this.untake.emit(ur);
  }

  untakeHandlerConfirm(ur: UserRequest): void {
    this.toUntake = ur;
  }

  acceptHandler(ur: UserRequest): void {
    this.accept.emit(ur);
  }

  partialAcceptHandler(ur: UserRequest): void {
    this.partialAccept.emit(ur);
  }

  rejectHandler(ur: UserRequest): void {
    this.reject.emit(ur);
  }

}
